<script>
export default {
    name: "terms",
    data() {
        return {
            history: window.history.length,
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="terms">
        <div class="banner flex align_center justify_center">
            <div class="layout_bg bg" :style="`background-image: url(${require('@/assets/images/terms.jpg')});`"></div>
            <p class="name text_shadow">服务条款</p>
        </div>
        <!--  -->
        <div class="main layout_main">
            <div class="top">
                <p class="title">服务条款Terms of Service</p>
                <p class="time">最后更新日期：2025年7月24日</p>
            </div>
            <!--  -->
            <div class="content">
                <p>欢迎您访问并使用由奢颜（以下简称“本公司”或“Ambassador+”）运营的网站（以下简称“本网站”）。在您访问本网站或使用我们提供的任何服务前，请您仔细阅读以下服务条款。若您不同意本条款的任何内容，请停止使用本网站。您一旦使用，即视为您已完全理解并同意本条款的约束。</p>
            </div>
            <!--  -->
            <div class="content">
                <p class="h1">一、公司介绍与服务范围</p>
                <p>奢颜是一家专业的艺人与艺术家经纪公司，我们致力于为品牌客户提供：</p>
                <ul>
                    <li><p><b>艺人相关服务：</b> 商务代言、广告拍摄、活动出席、社媒推广等；</p></li>
                    <li><p><b>艺术家相关服务：</b> 品牌联名合作、艺术品授权、定制插画/图案/包装、现有作品授权与开发；</p></li>
                    <li><p><b>版权管理与合作策划：</b> 涵盖线上线下展览、产品包装、跨界合作等多种形式。</p></li>
                </ul>
                <p>本网站展示的所有内容仅用于信息交流与初步洽谈之用，具体合作应以正式合同为准。</p>
            </div>
            <!--  -->
            <div class="content">
                <p class="h1">二、合作流程说明</p>
                <ol>
                    <li>
                        <div class="text">
                            <p><b>意向沟通</b></p>
                            <p>客户可通过网站提供的联系方式（邮箱或在线表单）提交合作需求，包括项目简介、时间安排、预算范围等。</p>
                        </div>
                    </li>
                    <li>
                        <div class="text">
                            <p><b>资源匹配与提案</b></p>
                            <p>奢颜团队将根据客户需求推荐适合的艺人或艺术家，并提供合作方案及初步预算。</p>
                        </div>
                    </li>
                    <li>
                        <div class="text">
                            <p><b>合同签署与执行</b></p>
                            <p>经双方确认合作内容及权益条款后，签署正式合同，项目正式进入执行阶段。</p>
                        </div>
                    </li>
                    <li>
                        <div class="text">
                            <p><b>交付与结算</b></p>
                            <p>项目交付以合同约定为准，并根据进度完成付款与后续服务。</p>
                        </div>
                    </li>
                </ol>
            </div>
            <!--  -->
            <div class="content">
                <p class="h1">三、知识产权声明</p>
                <ol>
                    <li>
                        <div class="text">
                            <p><b>内容版权归属</b></p>
                            <p>本网站展示的所有内容，包括但不限于图像、插画、视频、文字、作品样稿、设计方案等，其版权归奢颜或其签约艺人/艺术家或授权合作方所有。</p>
                        </div>
                    </li>
                    <li>
                        <div class="text">
                            <p><b>禁止擅自使用</b></p>
                            <p>未经书面授权，任何机构或个人不得复制、转载、传播、二次修改、印刷、销售或以任何形式使用上述内容。违者将依法追究法律责任。</p>
                        </div>
                    </li>
                    <li>
                        <div class="text">
                            <p><b>授权与合作</b></p>
                            <p>若您希望获取某位艺术家的作品授权或定制合作，请直接联系我司。我们将在评估授权范围与用途后，与您进一步沟通。</p>
                        </div>
                    </li>
                </ol>
            </div>
            <!--  -->
            <div class="content">
                <p class="h1">四、网站使用规范</p>
                <ol>
                    <li>
                        <div class="text">
                            <p><b>禁止行为</b></p>
                            <p>用户在使用本网站时，不得进行以下行为：</p>
                            <ul>
                                <li><p>以任何方式干扰或破坏本网站正常运行；</p></li>
                                <li><p>试图未经授权访问本公司服务器、资料或其他用户信息；</p></li>
                                <li><p>进行任何可能侵犯第三方权利的行为。</p></li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <div class="text">
                            <p><b>信息准确性</b></p>
                            <p>本网站所展示信息由奢颜精心整理，但无法完全保证其时效性或无误。若有重要决策，建议直接联系工作人员确认。</p>
                        </div>
                    </li>
                </ol>
            </div>
            <!--  -->
            <div class="content">
                <p class="h1">五、免责声明</p>
                <ol>
                    <li>
                        <div class="text">
                            <p>本网站中所含信息仅作为参考，并不构成任何要约、保证或法律责任的承诺。</p>
                        </div>
                    </li>
                    <li>
                        <div class="text">
                            <p>奢颜不对因使用本网站信息或因合作未达成而产生的任何直接或间接损失承担责任。</p>
                        </div>
                    </li>
                    <li>
                        <div class="text">
                            <p>合作最终是否达成，取决于双方意愿、资源匹配、档期安排及合同条款。</p>
                        </div>
                    </li>
                </ol>
            </div>
            <!--  -->
            <div class="content">
                <p class="h1">六、适用法律与争议解决</p>
                <ol>
                    <li>
                        <div class="text">
                            <p>本服务条款适用中华人民共和国法律（不含港澳台地区）。</p>
                        </div>
                    </li>
                    <li>
                        <div class="text">
                            <p>若因本条款或合作事项发生争议，双方应友好协商解决；协商不成的，任一方可向本公司所在地人民法院提起诉讼。</p>
                        </div>
                    </li>
                </ol>
            </div>
            <!--  -->
            <div class="content">
                <p class="h1">七、条款更新与生效</p>
                <p>奢颜有权根据业务发展不定期更新本服务条款，更新后的内容将在本页面发布并即时生效。建议您定期查看本页面以了解最新信息。</p>
            </div>
            <!--  -->
            <div class="bottom flex justify_between align_center">
                <div class="l">
                    <p class="p1">奢颜 Ambassador <sup>+</sup></p>
                    <p class="p2">© 2025  奢颜  版权所有</p>
                </div>
                <div class="btn layout_flex_center" v-if="history > 2" @click="$router.go(-1)">返回</div>
                <router-link class="btn layout_flex_center" v-else to="/">返回</router-link>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.main{
    padding: .6rem 0;
    font-size: .2rem;
    line-height: 1.8;
    .bottom{
        .p1{
            font-size: .2rem;
        }
        .p2{
            font-size: .16rem;
        }
        .btn{
            line-height: 1;
            height: .42rem;
            border: 1px solid #000;
            padding: 0 .14rem;
            cursor: pointer;
        }
    }
    .content{
        border-bottom: 2px solid #c9c9c9;
        padding-bottom: .3rem;
        margin-bottom: .3rem;
    }
    .top{
        margin-bottom: .6rem;
    }
    .icon{
        width: .31rem;
        margin-right: .1rem;
    }
    p{
        margin-bottom: .3em;
    }
    b{
        color: #000;
    }
    ul{
        list-style: disc;
        padding-left: .3rem;
    }
    ol{
        list-style: auto;
        padding-left: .3rem;
    }
    .title,
    .time{
        text-align: center;
    }
    .title{
        font-size: .32rem;
        font-weight: bold;
        margin-bottom: .1rem;
    }
    .time{
        font-size: .22rem;
    }
    .h1{
        font-size: .22rem;
    }
}
.banner{
    height: 5.36rem;
    position: relative;
    .bg{
        position: absolute;
        z-index: -1;
        color: #fff;
    }
    .name{
        font-size: .36rem;
        font-weight: bold;
        color: #fff;
        margin-top: 1rem;
    }
}
</style>